export function clamp(v, a, b) {
  return Math.max(a, Math.min(b, v));
}

export function lerp(a, b, t) {
  return a + (b - a) * t;
}

export function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
}

export function randInt(min, maxInclusive) {
  return (Math.random() * (maxInclusive - min + 1) + min) | 0;
}

export function pick(arr) {
  return arr[(Math.random() * arr.length) | 0];
}
